import {
  APPLY_EXTENDED_FILTERS,
  APPLY_FILTERS,
  RESET_EXTENDED_FILTERS,
  RESET_FILTERS,
  SEARCH_SAVE_RESET,
  SEARCH_FORM_TOGGLE,
} from './actionTypes'

/**
 * Gets the current form data to commit the filters to the store.
 * @param {object} filters
 * @returns {object} Action Object
 */
export const filtersApply = filters => ({
  type: APPLY_FILTERS,
  payload: filters,
})

/**
 * Gets the current form data to commit the extended filters to the store.
 * @param {object} extendedFilters
 * @returns {object} Action Object
 */
export const filtersExtendedApply = extendedFilters => ({
  type: APPLY_EXTENDED_FILTERS,
  payload: extendedFilters,
})

/**
 * Resets the extended filters.
 * @returns {object} Action Object
 */
export const filtersExtendedReset = () => ({
  type: RESET_EXTENDED_FILTERS,
})

/**
 * Resets the filters.
 * @returns {object} Action Object
 */
export const filtersReset = () => ({
  type: RESET_FILTERS,
})

/**
 * Toggle Search form visible.
 * @returns {object} Action Object
 */
export const searchFormToggle = () => ({
  type: SEARCH_FORM_TOGGLE,
})

/* TODO: Refactor */

/**
 * Resets the save search modal.
 * @returns {object} Action Object
 */
export const resetSaveSearch = () => ({
  type: SEARCH_SAVE_RESET,
})
